<template>
  <!-- 自定义导出对话框 -->
  <el-dialog title="导出" :visible.sync="visible" width="1280px" :before-close="close">
    <div class="export-box">
      <div class="not-checked">
        <div class="tips">勾选区</div>

          <div class="box-checked">
            <div class="title">账单信息</div>
            <div class="checked-value">
              <div class="checkout-all">
                <el-checkbox :indeterminate="billIsIndeterminate" v-model="billCheckAll" @change="handleBillCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedBillList" @change="handleCheckedBillListChange">
                <el-checkbox v-for="bill in bills" :disabled="bill.required" :label="bill.name" :key="bill.code" />
              </el-checkbox-group>
            </div>
          </div>

          <div class="box-checked">
            <div class="title">订单信息</div>
            <div class="checked-value">
              <div class="checkout-all">
                <el-checkbox :indeterminate="orderIsIndeterminate" v-model="orderCheckAll" @change="handleOrderCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedOrderList" @change="handleCheckedOrderListChange">
                <el-checkbox v-for="order in orders" :disabled="order.required" :label="order.name" :key="order.code" />
              </el-checkbox-group>
            </div>
          </div>

          <div class="box-checked">
            <div class="title">商品信息</div>
            <div class="checked-value">
              <div class="checkout-all">
                <el-checkbox :indeterminate="goodsIsIndeterminate" v-model="goodsCheckAll" @change="handleGoodsCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedGoodsList" @change="handleCheckedGoodsListChange">
                <el-checkbox v-for="good in goods" :disabled="good.required" :label="good.name" :key="good.code" />
              </el-checkbox-group>
            </div>
          </div>
      </div>

      <div class="checked">
        <div class="tips">
          已选区 <span class="text">{{ selected.length }}</span>
        </div>
        <ul id="checked-drag" class="checked-group">
          <li v-for="item in selected" :key="item.code" :data-id="item.code" class="checked-group-item">
            <span>{{ item.name }}</span>
            <i v-if="!item.required" class="el-icon-close" @click="() => removeSelectedCheckboxItem(item.name)" />
          </li>
        </ul>
      </div>
    </div>

    <span slot="footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button type="primary" size="medium" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import API from '@/api'
import { replaceStr } from '@/utils'
import { Sortable } from 'sortablejs'

export default {
  props: {
    parameter: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectLoading: false,
      userOptions: [], // 用户下拉框数据

      visible: false, // 自定义导出对话框 - 是否显示对话框

      // 导出字段中的英文标识对应关系
      correspondence: [],
      // 所有可导出的字段
      exportFields: [],
      selectedFieldsId: undefined,

      // 自定义导出对话框 - 账单信息
      billCheckAll: false, // 是否全选
      checkedBillList: [], // 当前已选项
      bills: [], // 复选框数据源
      billIsIndeterminate: false, // 全选按钮的半选中样式

      // 自定义导出对话框 - 订单信息
      orderCheckAll: false, // 是否全选
      checkedOrderList: [], // 当前已选项
      orders: [], // 复选框数据源
      orderIsIndeterminate: false, // 全选按钮的半选中样式

      // 自定义导出对话框 - 商品信息
      goodsCheckAll: false, // 是否全选
      checkedGoodsList: [], // 当前已选项
      goods: [], // 复选框数据源
      goodsIsIndeterminate: false, // 全选按钮的半选中样式

      selected: [], // 所有已选项
      showColumns: [],
      columnInfo: {}
    }
  },
  
  watch: {
    checkedBillList(value) {
      this.setSelected(value, 'bills')
    },
    checkedOrderList(value) {
      this.setSelected(value, 'orders')
    },
    checkedGoodsList(value) {
      this.setSelected(value, 'goods')
    }
  },
  methods: {
    // 显示弹窗
    show() {
      this.visible = true
      this.drag()
      this.getPublicSelectData()
    },

    /**
     * API 获取可导出字段的列表
     */
     async getPublicSelectData() {
      // let obj = {
      //   billInfo: [], // 账单信息
      //   orderInfo: [], // 订单信息     
      //   productInfo: [], // 商品信息
      // }
      try {
        let { data } = await API.getPublicSelectData({ type: 13, param: undefined })
        let { data: selectedFields } = await API.getExportFieldRecords(10)
        if (selectedFields) {
          this.selectedFieldsId = selectedFields.id
          selectedFields = JSON.parse(selectedFields.content)
          console.log("selectedFields", selectedFields)
        }
        if (data) {
          this.exportFields = data
          data.forEach((item) => {
            this.correspondence.push(item.fields)
            switch (item.name) {
              case '账单信息':
                if (item.fields && item.fields.length) {
                  this.bills = item.fields
                  if (selectedFields) {
                    this.checkedBillList = [...selectedFields.billInfo]
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedBillList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedBillList.length === item.fields.length) {
                    this.billCheckAll = true
                    this.billIsIndeterminate = false
                  }
                  if (this.checkedBillList.length > 0 && this.checkedBillList.length < item.fields.length) {
                    this.billCheckAll = false
                    this.billIsIndeterminate = true
                  }
                } else {
                  this.bills = []
                }
                break
              case '订单信息':
                if (item.fields && item.fields.length) {
                  this.orders = item.fields
                  if (selectedFields) {
                    this.checkedOrderList = [...selectedFields.orderInfo]
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedOrderList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedOrderList.length === item.fields.length) {
                    this.orderCheckAll = true
                    this.orderIsIndeterminate = false
                  }
                  if (this.checkedOrderList.length > 0 && this.checkedOrderList.length < item.fields.length) {
                    this.orderCheckAll = false
                    this.orderIsIndeterminate = true
                  }
                } else {
                  this.orders = []
                }
                break
              case '商品信息':
                if (item.fields && item.fields.length) {
                  this.goods = item.fields
                  if (selectedFields) {
                    this.checkedGoodsList = [...selectedFields.productInfo]
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedGoodsList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedGoodsList.length === item.fields.length) {
                    this.goodsCheckAll = true
                    this.goodsIsIndeterminate = false
                  }
                  if (this.checkedGoodsList.length > 0 && this.checkedGoodsList.length < item.fields.length) {
                    this.goodsCheckAll = false
                    this.goodsIsIndeterminate = true
                  }
                } else {
                  this.goods = []
                }
                break
            }
          })
          this.correspondence = this.correspondence.flat()
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },

    /**
     * 拖拽功能
     * 插件中文文档: https://www.itxst.com/sortablejs/neuinffi.html
     * 插件官方文档: https://github.com/SortableJS/Sortable/tree/master/plugins/MultiDrag
     */
     drag() {
      this.$nextTick(() => {
        let element = document.getElementById('checked-drag')
        if (element) {
          new Sortable(element, {
            handle: '.checked-group-item',
            draggable: '.checked-group-item',
            animation: 500,
            dataIdAttr: 'data-id'
          })
        }
      })
    },

    /**
     * 自定义导出对话框 - 账单信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleBillCheckAllChange(value) {
      if (value) {
        this.checkedBillList = this.bills.map((item) => item.name)
      } else {
        this.checkedBillList = []
        this.bills.forEach((item) => {
          if (item.required) {
            this.checkedBillList.push(item.name)
          }
        })
      }
      if (this.checkedBillList.length && this.checkedBillList.length < this.bills.length) {
        this.billIsIndeterminate = true
      } else {
        this.billIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 账单信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedBillListChange(value) {
      let checkedCount = value.length
      this.billCheckAll = checkedCount === this.bills.length
      this.billIsIndeterminate = checkedCount > 0 && checkedCount < this.bills.length
    },

    
    /**
     * 自定义导出对话框 - 订单信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
     handleOrderCheckAllChange(value) {
      if (value) {
        this.checkedOrderList = this.orders.map((item) => item.name)
      } else {
        this.checkedOrderList = []
        this.orders.forEach((item) => {
          if (item.required) {
            this.checkedOrderList.push(item.name)
          }
        })
      }
      if (this.checkedOrderList.length && this.checkedOrderList.length < this.orders.length) {
        this.orderIsIndeterminate = true
      } else {
        this.orderIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 订单信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedOrderListChange(value) {
      let checkedCount = value.length
      this.orderCheckAll = checkedCount === this.orders.length
      this.orderIsIndeterminate = checkedCount > 0 && checkedCount < this.orders.length
    },

    /**
     * 自定义导出对话框 - 商品信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleGoodsCheckAllChange(value) {
      if (value) {
        this.checkedGoodsList = this.goods.map((item) => item.name)
      } else {
        this.checkedGoodsList = []
        this.goods.forEach((item) => {
          if (item.required) {
            this.checkedGoodsList.push(item.name)
          }
        })
      }
      if (this.checkedGoodsList.length && this.checkedGoodsList.length < this.goods.length) {
        this.goodsIsIndeterminate = true
      } else {
        this.goodsIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 商品信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedGoodsListChange(value) {
      let checkedCount = value.length
      this.goodsCheckAll = checkedCount === this.goods.length
      this.goodsIsIndeterminate = checkedCount > 0 && checkedCount < this.goods.length
    },


    /**
     * 自定义导出对话框 - 设置已勾选项
     * @param {Array} value 已勾选的复选框数组
     * @param {String} original 可选项数组
     */
    setSelected(value, original) {
      let selected = []
      let unchecked = []
      this[original].forEach((item) => {
        if (value.includes(item.name)) {
          selected.push(item.name)
        } else {
          unchecked.push(item.name)
        }
      })
      unchecked.forEach((item) => {
        this.selected.forEach((inside, index) => {
          if (item === inside.name) {
            this.selected.splice(index, 1)
          }
        })
      })
      this.correspondence.forEach((item) => {
        if (selected.includes(item.name)) {
          this.selected = Array.from(new Set([...this.selected, item]))
        }
      })
    },

    /**
     * 自定义导出对话框 - 删除某个已选的复选框
     * @param {String} value 当前删除的复选框的值
     */
    removeSelectedCheckboxItem(value) {
      if (this.checkedBillList.includes(value)) {
        this.checkedBillList = this.checkedBillList.filter((item) => item !== value)
        this.handleCheckedBillListChange(this.checkedBillList)
      }
      if (this.checkedOrderList.includes(value)) {
        this.checkedOrderList = this.checkedOrderList.filter((item) => item !== value)
        this.handleCheckedOrderListChange(this.checkedOrderList)
      }
      if (this.checkedGoodsList.includes(value)) {
        this.checkedGoodsList = this.checkedGoodsList.filter((item) => item !== value)
        this.handleCheckedGoodsListChange(this.checkedGoodsList)
      }
      this.selected = this.selected.filter((item) => item.name !== value)
    },

    /**
     * 自定义导出 - 对话框保存按钮的事件
     */
    save() {
      if (this.selected.length === 0) {
        this.$message.warning('请选择需要导出的字段!')
        return
      }

      let ul = document.getElementById('checked-drag')
      let selected = []
      Array.from(ul.children).forEach((li) => {
        selected.push(li.getAttribute('data-id'))
      })

      const params = {
        fileType: 2,
        taskType: 19,
        condition: JSON.stringify({
          searchContent: this.parameter,
          sortFields: [...selected]
        })
      }

      let obj = {
        billInfo: [], // 账单信息
        orderInfo: [], // 订单信息
        productInfo: [] // 商品信息
      }

      this.exportFields.forEach((item) => {
        if (item.code === 'bill_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.billInfo.push(field.name)
            }
          })
        }
        if (item.code === 'order_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.orderInfo.push(field.name)
            }
          })
        }
        if (item.code === 'product_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.productInfo.push(field.name)
            }
          })
        }
      })

      API.setExportFieldRecords({ id: this.selectedFieldsId ? this.selectedFieldsId : undefined, type: 10, content: JSON.stringify(obj) })
        .then(() => {})
        .catch(() => {})

      API.dashboardImportExportFile(params)
        .then(() => {
          this.close()
          this.$message.success('操作成功，请到导入导出管理查看')
        })
        .catch(() => {
          this.$message.error('导出失败，请重新操作')
        })
    },

    /**
     * 自定义导出 - 对话框关闭的事件
     */
    close() {
      this.visible = false
      this.clear()
    },

    /**
     * 自定义导出 - 负责清除数据方法
     */
    clear() {
      this.correspondence = []
      this.billCheckAll = false
      this.checkedBillList = []
      this.billIsIndeterminate = false
      this.orderCheckAll = false
      this.checkedOrderList = []
      this.orderIsIndeterminate = false
      this.goodsCheckAll = false
      this.checkedGoodsList = []
      this.goodsIsIndeterminate = false

      this.selected = []
    },
  }
}
</script>

<style lang="scss" scoped>
.export-box {
  display: flex;
  border-radius: 4px;
  border: 1px solid #e9e9e9;
  .not-checked,
  .checked {
    padding: 10px;
    .tips {
      line-height: 18px;
      margin-bottom: 10px;
      .text {
        color: #99c41c;
        font-weight: 700;
      }
    }
  }

  .not-checked {
    flex: 9;
    border-right: 1px solid #e9e9e9;
    /deep/.el-tabs__content {
      .el-tab-pane {
        overflow: auto;
      }
    }
    .checkout-all {
      margin-bottom: 10px;
    }
    .el-checkbox-group {
      .el-checkbox {
        width: 30%;
        margin-right: 22px !important;
        margin-bottom: 6px !important;
      }
    }
  }

  .checked {
    flex: 3;
    .checked-group {
      width: 100%;
      min-height: 280px;
      max-height: 480px;
      height: calc(100% - 28px);
      overflow-y: auto;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      .checked-group-item {
        display: flex;
        width: 100%;
        line-height: 28px;
        padding: 5px 8px;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #dcdfe6;
        user-select: none;
        cursor: move;
        span {
          max-width: 258px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        i {
          width: 25px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          &:hover {
            color: #f56c6c;
          }
        }
      }
    }
  }
  .box-checked {
    margin: 20px 0;
    border: 1px solid #ccc;
    .title {
      border-bottom: 1px solid #ccc;
      padding: 10px;
    }
    .checked-value {
      padding: 10px;
    }
  }
}

</style>